export const CHECKOUT_NEW_ADDRESS_FIELD_VALUE = 'newAddress';
